<template>
  <require from="framework/value_converters/hide-by-property"></require>
  <require from="controls/bs-nav-item"></require>
  <require from="controls/bs-nav-group-item"></require>

  <div class="application-menu" ref="applicationMenu">
    <nav class="nav nav-pills flex-column">
      <div class="nav-item ${item.isActive ? 'active' : ''} ${item.settings.disabled ? 'disabled' : ''} ${item.settings.itemClass}" repeat.for="item of items | hideByProperty:'settings.hidden' & signal:'navigation-changed'">
        <div if.bind="item.isGroup" class="nav-group-item" as-element="bs-nav-group-item" item.bind="item" group-link-clicked.call="groupLinkClicked(navGroup)" link-clicked.call="linkClicked(nav, navGroup)"></div>
        <div else as-element="bs-nav-item" item.bind="item" link-clicked.call="linkClicked(nav)"></div>
      </div>
      <div class="collaps-settings">
        <a class="collaps-link" href="#" click.delegate="collapsClicked()" title="Collapse menu">
          <i class="fas fa-angle-double-left"></i>
        </a>
        <a class="expand-link" href="#" click.delegate="expandClicked()" title="Expand menu">
          <i class="fas fa-angle-double-right"></i>
        </a>
      </div>
    </nav>
  </div>
</template>
